import mapboxgl from 'mapbox-gl';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { bootstrapApplication } from '@angular/platform-browser';

// mapbox-gl builds its web worker by stringifying its own code into a Blob.
// Angular's esbuild production minifier hoists a shared variable out of those
// functions, so the Blob worker throws "St is not defined" and no tiles or
// geometries render (only client-side points do). Point the worker at the
// standalone, un-minified CSP worker asset instead — the documented workaround.
// Harmless in dev too, where the same asset is served.
const mapboxRuntime = mapboxgl as unknown as { workerUrl: string };
mapboxRuntime.workerUrl = new URL('mapbox-gl-csp-worker.js', document.baseURI).href;

if (window.location.hostname.includes('tmdigital.terramagna.com.br')) {
  window.location.replace('https://app.tmdigital.ag');
}

bootstrapApplication(AppComponent, appConfig).catch((err: unknown) => console.error(err));
